const LIST_URL = "/v1/settings/single";
const UPDATE_ERP_SETTINGS_URL = "/v1/settings/erp/update";
const UPDATE_GENERAL_SETTINGS_URL = "/v1/settings/general/update";
const UPDATE_MAIL_SETTINGS_URL = "/v1/settings/email/update";
const UPDATE_COMPANY_SETTINGS_URL = "http://172.16.2.3:1996/api/CompanyConfigs";

const SETTINGS_API_URL_LIST = {
    LIST_URL,
    UPDATE_ERP_SETTINGS_URL,
    UPDATE_GENERAL_SETTINGS_URL,
    UPDATE_MAIL_SETTINGS_URL,
    UPDATE_COMPANY_SETTINGS_URL,
}

export { SETTINGS_API_URL_LIST };